import React from 'react';
import TableHead from './TableHead';
import TableBody from './TableBody';

const Table = ({ items }) => {
    if (!items || (items.length === 0)) {
        return (
            <div className="alert alert-warning rounded-0">
                Nenhum item registrado para esta venda.
            </div>
        );
    }
    return (
        <table className="table align-items-center table-flush">
            <TableHead />
            <TableBody items={items} />
        </table>
    );
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/Pages/Orders/Details/Items/Table.js